import React from 'react';

import { IconInfoCircle, IconWorld } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@cfa/react-components';
import { Button, IconButton, Tooltip } from '@cfa/react-core';

interface TranslationsHeaderProps {
  isTranslatePending: boolean;
  noValidTranslations: boolean;
  onTranslateAll: () => void;
}

const TranslationsHeader: React.FC<TranslationsHeaderProps> = ({
  isTranslatePending,
  onTranslateAll,
  noValidTranslations,
}) => {
  const { t } = useTranslation();
  return (
    <div data-testid="translations-header">
      <div className="relative mt-6 flex w-full items-center justify-between">
        <Typography fontWeight="bold" variant="h4">
          {t('TrainingPlans.manageTranslations.translateTocurrentLanguage')}
        </Typography>
        <div className="flex flex-row items-center gap-2">
          <Tooltip.Root delay={250}>
            <IconButton
              aria-label={t(
                'TrainingPlans.manageTranslations.translateAllTooltip',
              )}
              size="md"
            >
              <IconInfoCircle />
            </IconButton>
            <Tooltip.Content placement="top">
              {t('TrainingPlans.manageTranslations.translateAllTooltip')}
            </Tooltip.Content>
          </Tooltip.Root>
          <Button
            className="flex items-center"
            color="secondary"
            data-testid="TranslateAllButton"
            isDisabled={noValidTranslations || isTranslatePending}
            onPress={onTranslateAll}
          >
            <IconWorld />
            <span className="ml-3">{t('Button.translateAll')}</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TranslationsHeader;
